import React from 'react';

import ThreeDView from '../../asset/3dVeiw.png';
import suroundVR from '../../asset/360VR.png';
import Talk from '../../asset/talk.png';
import Contract from '../../asset/contract.png';
import Draw from '../../asset/draw.png';
import Confirm from '../../asset/confirm.png';

import { 
  Wapper, 
  Button,
  Icon, 
} from './style';

const surbeyData = [
  { code: 0, name: '3D View', icon: ThreeDView },
  { code: 1, name: '360VR', icon: suroundVR },
  { code: 2, name: '톡문의', icon: Talk },
  { code: 3, name: '비대면 계약', icon: Contract},
  { code: 4, name: '영역그리기', icon: Draw },
  { code: 5, name: '현장촬영', icon: Confirm },
];

const Mission1Quiz = ({
  selectedResult,
  onClickItem,  
}) => {
  return (
    <Wapper>
      {surbeyData.map((value, index)=> (
        <Button 
          key={index}
          checked={selectedResult.includes(value.code)}
          onClick={onClickItem.bind(null, value.code)}
        > 
          <Icon src={value.icon} />
          {value.name}
        </Button>
      ))} 
    </Wapper>
  );
};

export default Mission1Quiz;
